import { useState } from "react";

import { Combobox } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

export const BrandChipContainer = ({
    children,
    unselectedBrands,
    onItemClick,
    isOpen,
}: {
    children: React.ReactNode;
    unselectedBrands: string[];
    onItemClick: (brand: string) => void;
    isOpen?: boolean;
}) => {
    const [searchValue, setSearchValue] = useState("");

    const filteredUnselectedBrands = unselectedBrands.filter((brand) =>
        brand.toLowerCase().includes(searchValue.toLowerCase()),
    );
    return (
        <Combobox
            placement="bottom-start"
            isOpen={isOpen}
        >
            <Combobox.Trigger>{children}</Combobox.Trigger>
            <Combobox.SearchInput
                onChange={setSearchValue}
                value={searchValue}
            />
            <Combobox.Content emptyState={translate("llm.sentiment_report.brand_chip_container.empty_state")}>
                {filteredUnselectedBrands.map((brand) => (
                    <Combobox.Option
                        key={brand}
                        onClick={() => {
                            onItemClick(brand);
                        }}
                    >
                        <Combobox.OptionLabel>{brand}</Combobox.OptionLabel>
                    </Combobox.Option>
                ))}
            </Combobox.Content>
        </Combobox>
    );
};
